
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries.
 */

/*global Vue*/

require('./bootstrap').default;
require('./cycle').default;
require('./debug').default;
require('./vh-fix').default;

import Echo from "laravel-echo"
window.Pusher = require('pusher-js');

import routes from './routes';
console.info(routes);
window.Vue = require('vue').default;

import VueRouter from 'vue-router';
Vue.use(VueRouter);

import VueResize from 'vue-resize';
Vue.use(VueResize);

import VueAutosize from 'vue-autosize';
Vue.use(VueAutosize)

import VModal from 'vue-js-modal';
Vue.use(VModal, { dialog: true })

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

import Autocomplete from 'vuejs-auto-complete'

import { EncryptStorage } from 'encrypt-storage';
window.EncryptStorage = EncryptStorage;

import Fontawesome from './fontawesome';
window.Fontawesome = Fontawesome;

import Vuex from 'vuex';
Vue.use(Vuex);
import vuexI18n from 'vuex-i18n';
import Locales from './vue-i18n-locales.generated.js';

window.Locales = Locales;

const store = new Vuex.Store();

window.zESettings = {
    webWidget: {
        position: {
            horizontal: 'left',
            vertical: 'bottom'
        },
        offset: {
            horizontal: '18px',
            vertical: '60px'
        },
        color: {
            theme: '#1A72A0',
            launcher: '#1A72A0',
            launcherText: '#ffffff',
            button: '#1A72A0',
            resultLists: '#1A72A0',
            header: '#1A72A0',
            articleLinks: '#1A72A0'
        },
    }
}

require('./vue-prototypes').default;

Vue.use(vuexI18n.plugin, store);

Vue.i18n.add('en', Locales.en);

if(!window.Locales["cy"].brand) {
    window.Locales["cy"].brand = window.Locales["en"].brand;
}
Vue.i18n.add('cy', Locales.cy);

if(!window.Locales["fr"].brand) {
    window.Locales["fr"].brand = window.Locales["en"].brand;
}
Vue.i18n.add('fr', Locales.fr);


require('./vue-components').default;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

var router = new VueRouter({
    //mode: 'history',
    mode: 'hash',
    routes: routes
});

window.routeHistory = [];
window.maxRouteHistory = 10;

router.beforeEach((to, from, next) => {
    window.routeHistory.push({to: JSON.parse(JSON.simpleStringify(to)), from: JSON.parse(JSON.simpleStringify(from)), next: JSON.parse(JSON.simpleStringify(next))});
    while(window.routeHistory.length > window.maxRouteHistory) {
        window.routeHistory.shift();
    }
    // console.log("router.beforeEach");
    // console.log(JSON.simpleStringify(from));
    // console.log(JSON.simpleStringify(to));
    next();
})

require('./error_reporting').default;

axios.interceptors.response.use(undefined, function (error) {
    if(typeof error == "object" && error.response) {
        if(error.response.status === 401) {
            console.log("Caught authentication exception. Redirecting to login.")
            window.location = "/";
        }
        if(error.response.status === 419) {
            console.log("Session timeout. Redirecting to login.")
            window.location = "/";
        }
        // A 503 with a data object in the body, with a message, is pretty much guaranteed to be
        // maintenance mode, not a server overload.
        if(error.response.status === 503 && error.response.data && error.response.data.message) {
            console.log("Caught 503 from server, assuming maintenance mode.")
            window.location = "/";
        }
    }
    return Promise.reject(error);
});

axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.api_token + ":" + window.provider_id;

import AppBase from './components/base/AppBase.vue';

import * as Survey from "survey-vue";
//import * as SurveyPDF from "survey-pdf";


window.Survey = Survey;
//window.SurveyPDF = SurveyPDF.SurveyPDF;
//window.SurveyPdf = SurveyPDF;

var app = new Vue({
    components: {
        Autocomplete,
        Survey,
    },
    extends: AppBase,
    el: '#app',
    data: {
        apiBase: "/api/v1",
        user: null,
        provider: {
            calc_service_status: -1, 
            campaigns_enabled: 0, 
            reports_enabled: 0, 
            custom_action: [], 
            clinician_gender_selection_enabled: 0
        },
        firstRoute: null,
        appStatusMessage: "Application loading ... please wait.",
        additionalInformation: "",
        notifications: [],
        now: Date.now(),
        connected: false,
        errors: [],
        auth: {password: "", email: ""},
        api_token: window.api_token,
        coreUpdateTimerMaxTimeout: 10000,
        requests: [],
        requests_loaded: false,
        request_update_cache: [],
        fontawesome: Fontawesome,
        userHasOther: {},
        createdByHasOther: {},
        requestSort: {field: "created_at", dir: "desc"},
        failed_filing_count: 0,
    },
    router: router,
    //store,
    created: function() {
        if(!this.environment_settings.MIX_ENABLE_LANGUAGE_SELECTION) {
            this.lookup.langs = {
                'en' : 'English'
            };
        }
        console.log("Capturing initial path during init: " + this.$route.path);
        if(window.location.pathname == "/" && this.$route.path == "/") {
            this.firstRoute = {path: "/home"};
            //this.$router.push({path: "/dashboard"});
        }
        else {
            if(this.$route.path == "/loading") {
                this.firstRoute = {path: "/home"};
            }
            else {
                this.firstRoute = {path: this.$route.path};
            }
        }
        if(this.$route.path != "/") {
            router.replace('/');
        }
        console.log("After init, will redirect to: " + this.firstRoute.path)

    },
    mounted: function() {
        console.log("Initialising application");

        //console.log(window.location.pathname);
        //console.log(this.firstRoute.path);
        
        if(this.supported_browser) {
            if(this.firstRoute.path == "/login"
                    || this.firstRoute.path.startsWith("/password")
                    || window.location.pathname == "/login"
                    || window.location.pathname.startsWith("/logged-out")
                    || window.location.pathname.startsWith("/logout")
                    || window.location.pathname == "/test_layout.html"
                    || window.location.pathname.startsWith("/password")
                    // This is a bug in the framework's password reset causing these
                    // double slash paths.
                    || window.location.pathname.startsWith("//password")
                    ) {
                this.loaded = true;
                console.log("Application initialised (without core)");
                this.$router.push(this.firstRoute);
            }
            else if(!this.isLoggedIn()) {
                this.loaded = true;
                console.log("Application initialised (without core)");
                if(!this.firstRoute.path.match(/^\/(login|password-reset)/)) {
                    this.firstRoute.path = "login";
                }
                this.$router.push(this.firstRoute);
                this.appvisible = true;
            }
            else {
                this.loadCore(true);
            }

            // if(this.$refs["email-sent"]) {
            //     this.auth.email = this.$refs["email-sent"].value;
            // }

            this.tableauEmbedPatch();
        }
        else {
            console.log("Unsupported browser detected. Refusing to run.");
        }
    },
    methods: {
        // Patch the undefined viz-filter element in to the customElement registry otherwise we get Vue warnings about it.
        
        updateUserRequestStats(thread) {
            if(thread.user) {
                if(!this.userHasOther[thread.user.id]) {
                    Vue.set(this.userHasOther, thread.user.id, 0);
                }
                this.userHasOther[thread.user.id] = this.requests.filter(obj => {return obj.user && obj.user.id === thread.user.id && !obj.closed_at}).length;
            }
            if(thread.created_by_user && this.is_patient(thread.created_by_user)) {
                if(!this.createdByHasOther[thread.created_by_user.id]) {
                    Vue.set(this.createdByHasOther, thread.created_by_user.id, 1);
                }
                this.createdByHasOther[thread.created_by_user.id] = this.requests.filter(obj => {return obj.created_by_user && obj.created_by_user.id === thread.created_by_user.id && !obj.closed_at}).length;
            }            
        },
        addOrUpdateItem(newItem, ignore = [], sent_check = true) {
            var found = false;
            var resort = false;
            var remove = false;

            if(!this.requests_loaded) {
                this.request_update_cache.push(newItem);
            }
            else {            
                // Set the correct thread_provider for the logged in user
                if(newItem.thread.thread_provider_xref) {
                    newItem.thread.thread_provider = newItem.thread.thread_provider_xref.find(obj => {return obj.provider_id == this.$root.user.provider.id});
                    
                    // If we can't find a matching xref for the current provider, then ignore the update.
                    // See AV3-1381, which details some weird multi-provider behaviour where new
                    // requests keep coming for the other provider after switch.
                    if(!newItem.thread.thread_provider) {
                        remove = true;
                    }
                }

                if(this.requests && Array.isArray(this.requests)) {
                    //console.log("Processing request update.");
                    for(var index in this.requests) {
                        if(this.requests[index].id == newItem.thread.id) {
                            found = true;
                            if(newItem.thread.deleted_at || remove) {
                                this.requests.splice(index, 1);
                            }
                            else {
                                //if(this.requests[index].updated_at < newItem.thread.updated_at) {
                                    // If the priority has changed, we need to re-sort the item in to the
                                    // correct slot
                                    if(newItem.thread.thread_provider.priority != this.requests[index].thread_provider.priority) {
                                        resort = true;
                                    }
                                    for (var attrname in newItem.thread) {
                                        if(!ignore.find(value => {return attrname == value})) {
                                            //console.log("Setting: " + attrname + ")" + this.requests[index][attrname] + " to " + newItem.thread[attrname]);
                                            this.requests[index][attrname] = newItem.thread[attrname];
                                        }
                                        else {
                                            //console.log("Ignoring: " + attrname);
                                        }
                                    }
                                    // If we need to re-sort, we take a copy of the item, delete the original,
                                    // and set found to false, to trigger the item to be re-inserted
                                    if(resort) {
                                        newItem.thread = this.requests[index];
                                        this.requests.splice(index, 1);
                                        found = false;
                                    }
                                // }
                                // else {
                                //     console.warn(`Received old update for ${newItem.thread.id}: local: ${this.requests[index].updated_at}, update: ${newItem.thread.updated_at}`)
                                // }
                            }
                        }
                    }
                }
                if(!found) {
                    // We get thread updates for clinical system writeback updates, but we don't add them to our current list.
                    // We need to still get them though, so that the other global listeners can update too.
                    if(newItem.thread.closed_at) {
                        return found;
                    }

                    // Only remove the ignored items if we aren't re-sorting an existing item because
                    // of a sort order (priority) change
                    if(!resort) {
                        for (var attrname in newItem.thread) {
                            if(ignore.find(value => {return attrname == value})) {
                                delete(newItem.thread[attrname]);
                            }
                        }
                    }
                    
                    var insertIndex = -1;
                    for (var index in this.requests) {
                        if(newItem.thread.thread_provider.priority > this.requests[index].thread_provider.priority) {
                            insertIndex = index;
                            break;
                        }
                        if(newItem.thread.thread_provider.priority == this.requests[index].thread_provider.priority) {
                            if(this.requestSort.dir == "desc" && newItem.thread.created_at > this.requests[index].created_at) {
                                insertIndex = index;
                                break;
                            }
                            else if(this.requestSort.dir == "asc" && newItem.thread.created_at < this.requests[index].created_at) {
                                insertIndex = index;
                                break;
                            }
                        }
                    }
                    //console.log(newItem.thread.thread_provider.priority, newItem.thread.created_at, insertIndex);
                    if(insertIndex === -1) {
                        this.requests.push(newItem.thread);
                    }
                    else {
                        this.requests.splice(insertIndex, 0, newItem.thread);
                    }
                }

                // Replay the previous update if this update was out of order.
                if(sent_check && this.last_request) {
                    //console.info(this.last_request.sent_at, newItem.sent_at);
                    if(this.last_request.sent_at > newItem.sent_at) {
                        //console.info("!!!!REPLAY!!!!");
                        this.addOrUpdateItem(this.last_request, ignore, false);
                    }
                }
                this.last_request = newItem;
            }

            this.updateUserRequestStats(newItem.thread);

            //console.log("updateItem: " + found);
            return found;
        },
        initRequestMessaging() {
            this.deInitChannels("private-thread.");
            window.Echo.private('thread.' + this.user.provider.id)
                .listen('NewThread', (e) => {
                    //console.log('NewThread', e.thread);
                    if(e.thread) {
                        this.addOrUpdateItem(e, ["user_thread_read_status"]);
                    }
                    else {
                        console.error("No thread data found in NewThread.")
                    }
                })
                this.listenWithChunking('thread.' + this.user.provider.id, 'UpdateThread', (e) => {
                    //console.log('UpdateThread', e.thread);
                    if(e.thread) {
                        this.addOrUpdateItem(e, ["user_thread_read_status"]);
                        this.callGlobalListener("UpdateThread", e);
                    }
                    else {
                        console.error("No thread data found in UpdateThread.")
                    }
                });
                this.listenWithChunking('thread.' + this.user.provider.id, 'UpdateThreadMin', (e) => {
                    //console.log('UpdateThreadMin', e.thread);
                    if(e.thread) {
                        this.addOrUpdateItem(e, ["user_thread_read_status"]);
                        this.callGlobalListener("UpdateThread", e);
                    }
                    else {
                        console.error("No thread data found in UpdateThreadMin.")
                    }
                });
                this.listenWithChunking('thread.' + this.user.provider.id, 'UpdateThreadImmediate', (e) => {
                    
                    //console.log('UpdateThreadImmediate', e.thread);
                    if(e.thread) {
                        this.addOrUpdateItem(e, ["user_thread_read_status"]);
                        this.callGlobalListener("UpdateThread", e);
                    }
                    else {
                        console.error("No thread data found in UpdateThreadImmediate.")
                    }
                });
        },
        resetRequestStats() {
            this.userHasOther = {},
            this.createdByHasOther = {},

            // OLD expensive way of doing this
            // this.requests.forEach(thread => {
            //     this.updateUserRequestStats(thread);
            // })

            // New inline fast way
            this.requests.forEach(thread => {
                if(!thread.closed_at) {
                    if(thread.user) {
                        if(!this.userHasOther[thread.user.id]) {
                            Vue.set(this.userHasOther, thread.user.id, 1);
                        }
                        else {
                            this.userHasOther[thread.user.id]++;
                        }
                    }
                    if(thread.created_by_user && this.is_patient(thread.created_by_user)) {
                        if(!this.createdByHasOther[thread.created_by_user.id]) {
                            Vue.set(this.createdByHasOther, thread.created_by_user.id, 1);
                        }
                        else {
                            this.createdByHasOther[thread.created_by_user.id]++;
                        }
                    }
                }
            })
        },
        setRequests(requests) {
            this.requestSort = this.getSetting("sort", {field: "created_at", dir: "desc"});
            this.requests_loaded = true;
            
            
            // requests.forEach(item => {
            //     //console.log({thread: item});
            //     // We do set the user_thread_read_status at this point as these are
            //     // queried via the API, not via websockets, so the read statuses are
            //     // correct for the current user.
            //     this.addOrUpdateItem({thread: item} /*, ["user_thread_read_status"]*/);
            // })
            
            this.requests = requests;
            
            

            this.resetRequestStats();

            this.sortRequests();

            console.log("Replaying the request update cache: " + this.request_update_cache.length);
            
            this.request_update_cache.forEach(item => {
                this.addOrUpdateItem(item, ["user_thread_read_status"]);
            })

            this.request_update_cache = [];
            
        },
        sortRequests() {
            this.requests.sort((a, b) => {
                if(a.thread_provider.priority == b.thread_provider.priority) {
                    if(a.created_at < b.created_at) {
                        return this.requestSort.dir == "desc" ? 1 : -1;
                    }
                    else if(a.created_at > b.created_at) {
                        return this.requestSort.dir == "desc" ? -1 : 1;
                    }
                }
                else {
                    // Opposite way around for priority
                    if (a.thread_provider.priority > b.thread_provider.priority) {
                        return -1;
                    }
                    else if (a.thread_provider.priority < b.thread_provider.priority) {
                        return 1;
                    }
                }
                return 0;
            });
        },
        setLoadingMessage(message, progress, progress_bar_class=null) {
            if(this.$refs.loadingMessages) {
                this.$refs.loadingMessages.textContent = message;
            }
            if(this.$refs.loadingMessageBar) {
                if(progress_bar_class) {
                    this.$refs.loadingMessageBar.className = progress_bar_class;
                }
                this.$refs.loadingMessageBar.style.width = progress + "%";
            }
            
        },
        async loadCore(init, route) {
            if(init) {
                this.loaded = false;
            }
            this.requests_loaded = false;
            this.setLoadingMessage('Initialising ...', 0);
            await this.$nextTick();
            this.setLoadingMessage('Checking websockets ...', 20);
            return this.checkPusher(15000, true).then((io_result) => {
                if(io_result && io_result.type != "previous") {
                    window.socket_io_result = io_result;
                }
                this.setLoadingMessage('Loading user ...', 30);
                this.loadUser().then((res) => {
                    this.user = res.data.user;

                    for (var attrname in this.user.provider) {
                        //console.log("Setting " + this.items.data[index][attrname] + " to " + newItem.thread[attrname]);
                        this.provider[attrname] = this.user.provider[attrname];
                    }
                    this.setBrand("provider");
                    window.provider_id = this.provider.id;
                    this.setLoadingMessage('Connecting websockets ...', 40);
                    this.initEcho();
                    this.initRequestMessaging();
                    this.setLoadingMessage('Loading application data ...', 70);
                    return axios.all([
                            this.loadLookup("users/relatedData"), 
                            this.loadLookup("usergroups"), 
                            this.loadLookup("tags"),
                            this.loadLookup("staff"), 
                            this.loadLookup("threads/getUserAssignedToday"),
                            this.loadLookup("filing/failedFilings"),
                            this.loadRequests()
                        ]).then(axios.spread((
                            userRelatedData, 
                            userGroups, 
                            tags,
                            staff, 
                            userAssignedToday,
                            failedFilings,
                            requests) => {
                        
                        this.setLocale();

                        this.getUserSettings();

                        // Load the previous provider setting
                        var local_provider_id = this.getSetting("provider_id");

                        // If it isn't the default (passed back by the server)
                        if(local_provider_id != window.provider_id) {
                            if(this.user.user_provider.find((obj) => {return obj.id == local_provider_id;})) {
                                console.info("Switching provider to locally set: " + local_provider_id);
                                window.provider_id = local_provider_id;
                                axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.api_token + ":" + window.provider_id;

                                // If we need to switch provider. Simply re-run the loadCore function from the top.
                                return this.loadCore(init, route);
                            }
                            else {
                                console.info("Locally set provider_id is not available to the user: " + local_provider_id);
                                this.setSetting("provider_id", window.provider_id);
                            }
                        }
                        
                        this.initActivityMonitoring();

                        this.initVideo();
                        this.initVisibilityHandlers();
                        this.freshdeskSetUser();

                        //this.initTableau();

                        //Vue.nextTick(() => {this.initNickelled()});

                        this.setLookup(userRelatedData.data);
                        this.setLookup(userGroups.data.data, "user_groups");
                        this.setLookup(tags.data.data, "tags");
                        this.setLookup(staff.data.data, "staff");
                        this.setLookup(userAssignedToday.data.user_assignment_today, "user_assignment_today");
                        this.setLookup(userAssignedToday.data.user_assignment, "user_assignment");
                        this.setLookup(userAssignedToday.data.user_completed_today, "user_completed_today");
                        this.setLookup(userAssignedToday.data.group_assignment_today, "group_assignment_today");
                        this.setLookup(userAssignedToday.data.group_assignment, "group_assignment");
                        this.setLookup(userAssignedToday.data.group_completed_today, "group_completed_today");
                        this.setLookup(userAssignedToday.data.transferred_provider_assignment, "transferred_provider_assignment");
                        this.setLookup(userAssignedToday.data.transferred_provider_assignment_today, "transferred_provider_assignment_today");
                        this.setLookup(userAssignedToday.data.shared_provider_assignment, "shared_provider_assignment");
                        this.setLookup(userAssignedToday.data.shared_provider_assignment_today, "shared_provider_assignment_today");
                        
                        
                        //this.setLookup(userAssignedToday.data.transferred_provider_assignment_waiting, "transferred_provider_assignment_waiting");


                        this.setFailedFilingCount(failedFilings.data);
                    
                        this.setLoadingMessage('Initialising and sorting requests ...', 90);
                        // Force a refresh of the loading bar
                        this.$nextTick();
                            
                        this.setRequests(requests.data);
                                
                        this.updateTimedEvents();

                        if(false && this.is_superuser() && window.socket_io_result && window.socket_io_result.type == 'failover') {
                            this.addNotification({timeout: 0, type: "warning", html: true, content: 'Our diagnostic shows that you are using a proxy connection, because the normal direct connection is disabled.  Superusers, please help us to help you:  go to Settings &rarr; Diagnostics and follow the instructions.  Local IT may need to make a small change, which is organisation wide, so this message will no longer show on login.<br /><br />Meanwhile, you can continue working normally.', route: {path: '/diagnostics', text: 'Go to diagnostics screen'}});
                        }

                        if(init) {
                            this.deInitChannels("private-core.");
                            window.Echo.private('core.' + this.user.provider.id)
                                .listen('UpdateCore', (e) => {
                                    this.loadCore();
                                    //this.addNotification({type: "success", content: 'Core application data updated'});
                                })
                                .listen('UpdateNotice', (e) => {
                                    this.updateNotice(e.news);
                                })
                                .listen('VideoCallReady', (e) => {
                                    //console.log(JSON.stringify(e));
                                    if(e.message.user_id == this.$root.user.id) {
                                        this.addNotification({timeout: 0, type: "warning", content: 'Incoming video call.', route: {path: '/thread-list/thread-show/' + e.message.thread_id, text: 'Go to thread'}});
                                    }
                                })
                                .listen('UpdateFiling', (e) => {
                                    //console.log("UpdateFiling", e.filing);
                                    if(e.filing && e.filing.user_id == this.$root.user.id) {
                                        if(e.filing.filing_status_id == 2) {
                                            this.addNotification({timeout: 0, type: "warning", content: 'Your filing failed for request: ' + e.filing.thread_id, route_persist: false, route: {path: '/thread-list/thread-show/' + e.filing.thread_id, text: 'Go to thread'}});
                                        }
                                    }
                                    this.setFailedFilingCount(e.failed_filings_by_user);
                                    this.callGlobalListener("UpdateFiling", e);
                                })
                                .listen('UpdateUserAssignedToday', (e) => {
                                    //console.log('UpdateUserAssignedToday');
                                    //console.log(JSON.stringify(e));
                                    this.$root.lookup.user_assignment_today = e.user_assignment_today
                                    this.$root.lookup.user_assignment = e.user_assignment
                                    this.$root.lookup.user_completed_today = e.user_completed_today

                                    this.$root.lookup.group_assignment_today = e.group_assignment_today;
                                    this.$root.lookup.group_assignment = e.group_assignment;
                                    this.$root.lookup.group_completed_today = e.group_completed_today;

                                    this.$root.lookup.transferred_provider_assignment = e.transferred_provider_assignment;
                                    this.$root.lookup.transferred_provider_assignment_today = e.transferred_provider_assignment_today;
                                    this.$root.lookup.shared_provider_assignment = e.shared_provider_assignment;
                                    this.$root.lookup.shared_provider_assignment_today = e.shared_provider_assignment_today;

                                });

                                this.listenWithChunking('core.' + this.user.provider.id, 'UpdateUserGroups', (e) => {
                                    //console.info(e.provider, this.provider);
                                    this.setLookup(e.user_groups, "user_groups");
                                    this.updateTimedEvents();
                                    //this.addNotification({type: "success", content: 'Core application data updated'});
                                });

                                this.listenWithChunking('core.' + this.user.provider.id, 'UpdateProvider', (e) => {
                                    //console.info(e.provider, this.provider);
                                    for (var attrname in e.provider) {
                                        //console.log("Setting " + this.items.data[index][attrname] + " to " + newItem.thread[attrname]);
                                        this.provider[attrname] = e.provider[attrname];
                                    }
                                    this.updateTimedEvents();
                                    //this.addNotification({type: "success", content: 'Core application data updated'});
                                });

                                this.listenWithChunking('core.' + this.user.provider.id, 'UpdateStaff', (e) => {
                                    console.info("UpdateStaff", e.staff);
                                    this.addOrUpdateStaff(e.staff);
                                    this.updateTimedEvents();
                                    //this.addNotification({type: "success", content: 'Core application data updated'});
                                });

                                this.listenWithChunking('core.' + this.user.provider.id, 'UpdateData', (e) => {
                                    // console.info(e);
                                    this.addOrUpdateData(e);
                                    //this.updateTimedEvents();
                                    //this.addNotification({type: "success", content: 'Application data updated'});
                                });
                            //this.deInitChannels('private-core');
                            // window.Echo.private('core')
                            //     .listen('UpdateNetworkCore', (e) => {
                            //         this.loadCore();
                            //         //this.addNotification({type: "success", content: 'Core application data updated'});
                            //     })
                            //     .listen('UpdateNotice', (e) => {
                            //         console.log(e);
                            //         this.updateNotice(e.notice);
                            //     });

                            this.getActiveNotice();
                            this.checkPendingMaxAge();

                            var timeoutDate = new Date();

                            // Update staff and service status every 60 seconds
                            setTimeout(() => {
                                setInterval(() => {
                                    this.updateTimedEvents();
                                }, 60000);
                                this.updateTimedEvents();
                            }, (60 - timeoutDate.getSeconds()) * 1000);

                            this.setLoadingMessage('Application initialised', 100);
                            console.log("Application initialised");
                            if(route) {
                                this.$router.push(route);
                            }
                            else {
                                this.$router.push(this.firstRoute);
                            }
                            this.loaded = true;
                            
                        //    this.$el.style.visibility = "visible";
                        }
                        this.setLoading(false);                                    
                    }))
                    .catch(error => {
                        this.loaded = false;
                        this.failedToLoad = true;
                        this.setLoading(false);
                        this.handleError(error, "init");
                        this.appStatusMessage = "The application failed to load correctly. Please try again later.";
                        this.setLoadingMessage('The application failed to load correctly. Please try again later.', 100, "progress-bar bg-danger");
                        this.additionalInformation = JSON.stringify(error, null, 2);
                    });
                })
                .catch(error => {
                    this.loaded = false;
                    this.failedToLoad = true;
                    this.setLoading(false);
                    this.handleError(error, "init");
                    this.appStatusMessage = "The application failed to load correctly. Please try again later.";
                    this.setLoadingMessage('The application failed to load correctly. Please try again later.', 100, "progress-bar bg-danger");
                    this.additionalInformation = JSON.stringify(error, null, 2);
                });
            })
            .catch(error => {
                this.loaded = false;
                this.failedToLoad = true;
                console.warn(error)
                this.setLoading(false);
                this.handleError(error, "init");
                this.appStatusMessage = "The application failed to load correctly. Please try again later.";
                this.setLoadingMessage('The application failed to load correctly. Please try again later.', 100, "progress-bar bg-danger");
                this.additionalInformation = JSON.stringify(error, null, 2);
            });
        },

        
        async loadRequests() {
            
                var next_page_url = this.apiBase + '/threads/current';
                var request = {
                    data: []
                };
                do {
                    await axios.get(next_page_url).then((res) => {
                        request.data = request.data.concat(res.data.data);
                        next_page_url = res.data.next_page_url;
                    });
                }
                while(next_page_url);
                
                return Promise.resolve(request);
        },
        updateTimedEvents() {
            for(var index in this.lookup.staff) {
                this.setAvailability(this.lookup.staff[index], 0, 0);
            }

            // The custom actions rely on the service status for some of their availability so remember
            // to set that first.
            this.setServiceStatus();
            
            for(var index in this.provider.custom_action) {
                Vue.set(this.provider.custom_action[index], "available", 0);
                switch(this.provider.custom_action[index].allow_out_of_hours) {
                    case 0:
                        this.provider.custom_action[index].available = 
                            this.$root.provider.calc_service_status == this.$root.lookup.service_status.AVAILABLE
                            || this.$root.provider.calc_service_status == this.$root.lookup.service_status.OOH_AVAILABLE;
                        break;
                    case 1:
                        this.provider.custom_action[index].available = true;
                        break;
                    case 2:
                        this.setAvailability(this.provider.custom_action[index], 0, 0, false);
                        break;
                }
            }
            
        },
        setFailedFilingCount(failedFilings) {
            if(failedFilings[this.user.id]) {
                this.failed_filing_count = failedFilings[this.user.id];
            }
            else {
                this.failed_filing_count = 0;
            }

        }
    }
});

window.app = app;
